import React, { useState } from 'react';
import styles from './MobileProfile.module.css';
import { useAuth } from 'src/hooks/useAuth';
import { Avatar } from '@mui/material';
import EditProfileModal from './EditProfileModal';
import { useSearchParams } from 'react-router-dom';

const MobileProfile = () => {
  const { data: profileData } = useAuth();
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [searchParams] = useSearchParams();

  React.useEffect(() => {
    if (searchParams.get('edit') === '1') {
      setEditModalOpen(true);
    }
  }, [searchParams]);

  const InfoRow = ({ label, value }) => (
    <div className={styles.infoRow}>
      <span className={styles.infoLabel}>{label}</span>
      <span className={styles.infoValue}>{value || 'N/A'}</span>
    </div>
  );

  const handleProfileUpdate = () => {
    // The modal now handles updating the auth context,
    // so we just need to close it.
    setEditModalOpen(false);
  };

  if (!profileData) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: 'white' }}>
        {/* You can use a spinner component here if you have one */}
        <p>Loading...</p>
      </div>
    );
  }

  const isBrand = profileData.merchant_type === 'brand';
  const isShop = profileData.merchant_type === 'shop';
  const isAdmin = profileData.user_type === 'admin';

  return (
    <>
      <div className={styles.profileContainer}>
        <div className={styles.profileHeader}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <img
                src="/assets/icons/arrowDown.svg"
                alt="Back"
                style={{ width: 24, height: 24, transform: 'rotate(90deg)', cursor: 'pointer', marginRight: '16px' }}
                onClick={() => window.history.back()}
              />
            <span>Store Profile</span>
          </div>
          {/* Only main merchants and non-admins can edit */}
          {(isShop && profileData?.is_main_merchant) && (
            <button 
              onClick={() => setEditModalOpen(true)}
              className={styles.editButton}
            >
              Edit
            </button>
          )}
           {isBrand && (
            <button 
              onClick={() => setEditModalOpen(true)}
              className={styles.editButton}
            >
              Edit
            </button>
          )}
        </div>

        {isBrand && (
           <div className={styles.infoSection}>
            <div className={styles.infoRow}>
              <span className={styles.infoLabel}>Business Logo</span>
              <img 
                src={profileData?.business_logo || profileData?.business_image || '/assets/images/avatars/avatar_default.jpg'} 
                alt="Business Logo" 
                className={styles.storeLogo} 
              />
            </div>
            <InfoRow label="Brand ID" value={profileData?.brandID} />
            <InfoRow label="Business Name" value={profileData?.business_name} />
            <InfoRow label="Business Email" value={profileData?.business_email} />
            <InfoRow label="Phone Number" value={profileData?.business_phone_number} />
            <InfoRow label="Address" value={profileData?.business_address} />
            <InfoRow label="Country" value={profileData?.country} />
            <InfoRow label="State" value={profileData?.state} />
         </div>
        )}

        {isShop && (
          <div className={styles.infoSection}>
            <div className={styles.infoRow}>
              <span className={styles.infoLabel}>Store Logo</span>
              <img 
                src={profileData?.store_logo || '/assets/images/avatars/avatar_default.jpg'} 
                alt="Store Logo" 
                className={styles.storeLogo} 
              />
            </div>
            <InfoRow label="Store Name" value={profileData?.store_name} />
            <InfoRow label="Store ID" value={profileData?.shopID} />
            <InfoRow label="Email Address" value={profileData?.email} />
            <InfoRow label="Phone Number" value={profileData?.store_phone_number} />
            <InfoRow label="Address" value={profileData?.store_address} />
            <InfoRow label="Country" value={profileData?.country} />
            <InfoRow label="State" value={profileData?.state} />
            <InfoRow label="Monthly Income" value={profileData?.monthly_income} />
            <InfoRow label="Store Category" value={profileData?.store_category} />
            <InfoRow label="Onboarded by" value={profileData?.onboarder_id} />
            <InfoRow label="Bank Name" value={profileData?.store_bank_name} />
            <InfoRow label="Account Name" value={profileData?.store_account_name} />
            <InfoRow label="Account Number" value={profileData?.store_account_number} />
          </div>
        )}
        
        {isAdmin && (
            <div className={styles.infoSection}>
                 <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Profile Image</span>
                    <Avatar 
                        src={profileData?.store_logo}
                        alt="Admin" 
                        className={styles.storeLogo}
                    />
                 </div>
                <InfoRow label="Admin Name" value={profileData?.first_name} />
                <InfoRow label="Email Address" value={profileData?.email} />
                <InfoRow label="Phone Number" value={profileData?.phone_number} />
                <InfoRow label="Admin Role" value={"Super Admin"} />
            </div>
        )}
      </div>
      
      {/* The modal is only available for merchants */}
      {!isAdmin && (
        <EditProfileModal 
          isOpen={isEditModalOpen}
          onClose={() => setEditModalOpen(false)}
          onProfileUpdate={handleProfileUpdate}
        />
      )}
    </>
  );
};

export default MobileProfile; 